import { __awaiter } from "tslib";
import log from 'pathfinder/utils/log';
import { getServicesBaseURL } from 'utils/env';
/**
 *
 * This function will subscribe the user provided email to Fandom's marketing mailing list
 * {string} email
 * {() => void} [onSuccess]
 * {() => void} [onFail]
 */
const subscribeToMailingList = (email, onSuccess, onFail, source = 'pathfinder') => __awaiter(void 0, void 0, void 0, function* () {
    const marketingEmailSignupUrl = `${getServicesBaseURL()}email-service/marketing/subscribe-email`;
    // TODO: Should we make this a generic utility function? Something along the lines of fetchWithTimeout()?
    // Let's add a timeout controller so that the fetch request can timeout after x amount of seconds
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), 10000);
    try {
        const response = yield fetch(marketingEmailSignupUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email,
                // Make sure that if the 'source' param is different than the default value of 'PATHFINDER',
                // then ensure that this code is fixed up with some kind of conditional statement.
                // Check the Pandora email-service to see what the valid values of sourceApp are,
                // otherwise this network call might end up failing each time.
                sourceApp: source.toUpperCase(),
            }),
            signal: controller.signal,
        });
        clearTimeout(id);
        if (response.ok) {
            const responseBody = response.body;
            log.debug('Successfully subscribed to a marketing email list: ', responseBody);
            onSuccess();
        }
        else {
            log.debug('Failed to subscribe to a marketing email list: ', response);
            onFail();
        }
    }
    catch (error) {
        onFail();
        log.error('Failed to subscribe to a marketing email list due to an error: ', error);
    }
});
export { subscribeToMailingList };
